module.exports = __webpack_public_path__ + "static/img/jh.d0289dc0.png";